type EventHandler = (eventData: any) => void;

interface EventHandlerMap {
	[eventName: string]: EventHandler[];
}

export default class ViewsEventBus {
	private eventHandlers: EventHandlerMap;

	constructor() {
		this.eventHandlers = {};
	}

	public $on(eventName: string, handler: (eventData: any) => void) {
		if (!this.eventHandlers[eventName]) {
			this.eventHandlers[eventName] = [];
		}
		this.eventHandlers[eventName].push(handler);
	}

	public $off(eventName: string, handler: (eventData: any) => void) {
		if (!this.eventHandlers[eventName]) return;

		let handlerIndex = this.eventHandlers[eventName].findIndex(h => h === handler);
		this.eventHandlers[eventName].splice(handlerIndex, 1);
	}

	public $emit(eventName: string, eventData: any) {
		if (!this.eventHandlers[eventName]) return;

		// Fire the event to all the handlers listening
		this.eventHandlers[eventName].forEach(handler => handler(eventData));
	}
}
